import posed from 'react-pose';

let AnimatedDivOpacity = posed.div({
    visibleOpacity: {
        opacity: 1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    },
    hiddenOpacity: {
        opacity: 0,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    }
});

export default AnimatedDivOpacity;



// WEBPACK FOOTER //
// ./src/animations/src/AnimatedDivOpacity.js